import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { FilterData, FilterGroupData, FilterSettings, IMapFilterDropdown } from './map.interfaces';

import { FilterContext } from './mapFilter';
import MapFilterToggle from './mapFilterToggle';

const MapFilterDropdown = ({ id, filterGroupData }: IMapFilterDropdown) => {
  const [filterGroup, setFilterGroup] = useState<FilterData[]>([]);
  const [groupChecked, setGroupChecked] = useState(false);
  const [contentExpanded, setContentExpanded] = useState(false);
  const [data, setData] = useState<FilterGroupData | null>(null);

  const { activeFilterGroup, setActiveFilterGroup, activeFilters, setActiveFilters } =
    useContext<FilterSettings>(FilterContext);

  // ----------------------------------------------------
  // USE LAYOUT EFFECT - close dropdown if another
  //                     is active
  // ----------------------------------------------------

  useLayoutEffect(() => {
    if (activeFilterGroup !== id) {
      setContentExpanded(false);
    }
  }, [activeFilterGroup, id]);

  activeFilters;

  // ------------------------------------------------------------
  // USE EFFECT - read filterGroupData and set the data
  // ------------------------------------------------------------

  useEffect(() => {
    if (filterGroupData) {
      setData(filterGroupData);
      setGroupChecked(filterGroupData.groupSelected);

      const group: FilterData[] = filterGroupData.filters.map((groupData) => {
        return {
          id: groupData.id,
          title: groupData.title,
          selected: groupData.selected,
        };
      });

      setFilterGroup(group);
    }
  }, [filterGroupData]);

  // ------------------------------------------------------------
  // USE EFFECT - check if context activeFilters changed
  // ------------------------------------------------------------

  useEffect(() => {
    if (activeFilters && data) {
      if (filterGroup?.length > 0) {
        const activeFilterInGroup = filterGroup.filter((filter) =>
          activeFilters.some((activeFilterId) => activeFilterId === filter.id)
        );
        setGroupChecked(activeFilterInGroup.length >= filterGroup.length);
      } else {
        const isFilterActive = activeFilters.some((activeFilterId) => activeFilterId === data.id);
        setGroupChecked(isFilterActive);
      }
    }
  }, [activeFilters]);

  // --------------------------------------------v--------------
  // HANDLE CHANGE CHECK -group checkbox checked/unchecked
  // -----------------------------------------------------------

  const handleChangeCheck = () => {
    const checked = groupChecked ? false : true;
    if (filterGroup?.length > 0) {
      filterGroup.forEach((filter) => {
        const filterIndex = activeFilters.findIndex((filterId) => filterId == filter.id);

        if (checked) {
          if (filterIndex < 0) {
            activeFilters.push(filter.id);
            setActiveFilters([...activeFilters]);
          }
        } else {
          if (filterIndex >= 0) {
            activeFilters.splice(filterIndex, 1);
            setActiveFilters([...activeFilters]);
          }
        }
      });
    } else {
      const filterIndex = activeFilters.findIndex((filterId) => filterId == data?.id);

      if (checked) {
        if (filterIndex < 0 && data) {
          activeFilters.push(data.id);
          setActiveFilters([...activeFilters]);
        }
      } else {
        if (filterIndex >= 0) {
          activeFilters.splice(filterIndex, 1);
          setActiveFilters([...activeFilters]);
        }
      }
    }

    setGroupChecked(checked);
  };

  // --------------------------------------------v--------------
  // EXPAND BUTTON CLICK - expandbutton click event
  // -----------------------------------------------------------

  const expandButtonClick = () => {
    setContentExpanded(contentExpanded ? false : true);
  };

  useEffect(() => {
    if (contentExpanded) {
      setActiveFilterGroup(id);
    }
  }, [contentExpanded]);

  // ------------------------------------
  // JSX
  // ------------------------------------

  return (
    <div className={`map-filter-dropdown ${groupChecked ? 'checked' : ''}`}>
      <div className="map-filter-dropdown-top-content">
        <label className="map-filter-dropdown-label">
          {data?.title}
          <input type="checkbox" defaultChecked={groupChecked} onChange={() => handleChangeCheck()} />
          <span className="custom-checkbox"></span>
        </label>
        {data && data.filters.length > 0 ? (
          <button
            title={contentExpanded ? 'Close filter dropdown' : 'Expand filter dropdown'}
            type="button"
            className="expand-button"
            onClick={expandButtonClick}
          >
            <i className={`icon bi  ${contentExpanded ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
          </button>
        ) : null}
      </div>
      <div className={`map-filter-expanded-content ${(contentExpanded && 'expanded') || ''}`}>
        {data?.filters.map((filter: FilterData) => (
          <MapFilterToggle key={filter.id} filterData={filter} />
        ))}
      </div>
    </div>
  );
};

export default MapFilterDropdown;
